import {
	getNameExtensionFromFileName,
	removeConsecutiveDashesUnderscores,
	replaceSpecialCharsWithDashes,
} from '../../../services/helpers'

export const getRenamedFileName = (
	file: File,
	renameParts?: string[]
) => {
	if (!renameParts?.length) {
		return file.name
	}

	const { extension } = getNameExtensionFromFileName(file.name)
	return removeConsecutiveDashesUnderscores(
		`${replaceSpecialCharsWithDashes(renameParts.join('_'))}_${file.lastModified}.${extension}`
	).toLowerCase()
}

export const renameFile = (file: File, renameParts?: string[]) => {
	const fileName = getRenamedFileName(file, renameParts)
	return new File([file], fileName, {
		type: file.type,
	})
}
